import { useTranslation } from "react-i18next";
import ContactForm from "../components/ContactForm";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { SITE } from "../data/site";
import { useL } from "../lib/useLang";

export default function Contact() {
  const { t } = useTranslation();
  const L = useL();

  const channels = [
    {
      icon: "phone",
      label: t("contact.phoneLabel"),
      value: SITE.phoneDisplay,
      href: `tel:${SITE.phone}`,
      note: t("contact.phoneNote"),
    },
    {
      icon: "whatsapp",
      label: t("contact.whatsappLabel"),
      value: SITE.whatsappDisplay,
      href: `https://wa.me/${SITE.whatsapp}`,
      external: true,
      note: t("contact.whatsappNote"),
    },
    {
      icon: "mail",
      label: t("contact.emailLabel"),
      value: SITE.email,
      href: `mailto:${SITE.email}`,
      note: t("contact.emailNote"),
    },
    {
      icon: "pin",
      label: t("contact.addressLabel"),
      value: SITE.address.full,
      note: t("contact.addressNote"),
    },
  ];

  return (
    <section className="fsg-section fsg-contact-section" id="contacto">
      <div className="fsg-container">
        <SectionHead
          eyebrow={t("contact.eyebrow")}
          title={t("contact.title")}
          lead={t("contact.lead")}
        />

        <div className="fsg-contact">
          <Reveal>
            <h3 style={{ fontSize: "var(--fsg-fs-h4)" }}>
              {t("contact.channelsTitle")}
            </h3>

            <div className="fsg-contact__channels">
              {channels.map((channel) => (
                <div className="fsg-channel" key={channel.icon}>
                  <span className="fsg-channel__icon">
                    <Icon name={channel.icon} />
                  </span>
                  <div>
                    <strong>{channel.label}</strong>
                    {channel.href ? (
                      <a
                        href={channel.href}
                        target={channel.external ? "_blank" : undefined}
                        rel={channel.external ? "noreferrer" : undefined}
                      >
                        {channel.value}
                      </a>
                    ) : (
                      <span className="value">{channel.value}</span>
                    )}
                    <small>{channel.note}</small>
                  </div>
                </div>
              ))}

              <div className="fsg-channel">
                <span className="fsg-channel__icon">
                  <Icon name="clock" />
                </span>
                <div>
                  <strong>{L(SITE.hours)}</strong>
                  <small>{t("contact.addressNote")}</small>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <ContactForm />
          </Reveal>
        </div>

      </div>
    </section>
  );
}
